import "./Contact.css";

export default function Contact() {
  // Nội dung tin nhắn mặc định
  const smsMessage = encodeURIComponent(
    "Chào shop, tôi muốn rút tiền thẻ tín dụng, báo phí ưu đãi hôm nay giúp tôi qua zalo: .",
  );

  return (
    <div>
      <div className="floating-contact">
        {/* SMS */}
        <a
          onClick={() => {
            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({
              event: "mess",
            });
          }}
          href={`sms:0941395019?body=${smsMessage}`}
          className="sms-pill"
        >
          <span className="sms-pill__text">Nhắn Tin</span>

          <span className="sms-pill__icon">💬</span>
        </a>

        {/* CALL */}
        <a
          onClick={() => {
            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({
              event: "goi",
            });
          }}
          href="tel:0941395019"
          className="contact-btn call"
        >
          <span className="pulse"></span>

          <img src="/call.svg" alt="Call" />
        </a>
      </div>
    </div>
  );
}
